import {Map} from 'immutable';
import {
  LOAD_SCHOOL_FULFILLED,
  LOAD_SCHOOL_PENDING,
  LOAD_SCHOOL_REJECTED,
} from '../actions';

const initialState = new Map({
  schoolName: '',
  ticketCount: 0
});

export default function (state = initialState, action) {
  switch (action.type) {
    case LOAD_SCHOOL_FULFILLED:
      return state.withMutations(map => {
        let ticketCount = 0;
        let schoolName = '';
        if (action.payload.data) {
          ticketCount = action.payload.data.currentSchoolYear ? action.payload.data.currentSchoolYear.currentTicketCount || 0 : 0;
          schoolName = action.payload.data.name || '';
        }
        map.set('schoolName', schoolName)
          .set('ticketCount', ticketCount);
      });

    case LOAD_SCHOOL_REJECTED:
      return state.set('loading', false);

    case LOAD_SCHOOL_PENDING:
      return state.set('loading', true);

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/features/sideNavigationTitle/reducers/sideNavigationTitle.js